<template>
  <div>
    <invoice-print :sale.sync="sale" :salesItems.sync="saleReturn"></invoice-print>
  </div>
</template> 

<script>
import InvoicePrint from '@/views/pos/pdf/InvoicePrint.vue'
import { mapActions, mapState } from 'vuex'
import { paymentMixins } from '@/utils/paymentTypes'

export default {
  name: 'PrintInoice',

  data() {
    return {
      saleDetails: null,
      saleReturn: []
    }
  },

  async mounted() {
    await this.getSaleById(this.$route.params.saleId)
    this.saleDetails = { ...this.sale, sales_return_date: new Date(), return_note: '' }
    this.saleReturn = this.salesItems.map((item) => ({
      ...item,
      return_qty: 0
    }))

    if (this.saleDetails) {
      await this.managesalesReturnData()
    }
  },

  mixins: [paymentMixins],

  computed: {
    ...mapState('pos', ['sale', 'salesItems'])
  },

  methods: {
    ...mapActions('pos', { getSaleById: 'getSaleById' }),
    print() {
      window.print()
    },

    async managesalesReturnData() {
      // if no record foun for previous sale return then do nothing
      if (!this.saleDetails.sales_return) {
        return null
      }

      this.saleDetails.sales_return.salesItemsReturn.forEach((element) => {
        const tempElementIndex = this.saleReturn.findIndex((elem) => elem.productId === element.productId)

        if (tempElementIndex > -1) {
          const availableQty = this.saleReturn[tempElementIndex].sales_qty - element.return_qty
          this.saleReturn[tempElementIndex].tot_discount = (availableQty * this.saleReturn[tempElementIndex].tot_discount) / this.saleReturn[tempElementIndex].sales_qty // product discount
          this.saleReturn[tempElementIndex].tot_price -= element.tot_per_unit
          this.saleReturn[tempElementIndex].city_tax_amt = (availableQty * this.saleReturn[tempElementIndex].city_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // city tax
          this.saleReturn[tempElementIndex].county_tax_amt = (availableQty * this.saleReturn[tempElementIndex].county_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // county tax
          this.saleReturn[tempElementIndex].excise_tax_amt = (availableQty * this.saleReturn[tempElementIndex].excise_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // excise tax
          this.saleReturn[tempElementIndex].state_tax_amt = (availableQty * this.saleReturn[tempElementIndex].state_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // state tax
          this.saleReturn[tempElementIndex].tot_taxes_amt = (availableQty * this.saleReturn[tempElementIndex].tot_taxes_amt) / this.saleReturn[tempElementIndex].sales_qty // product total tax
          this.saleReturn[tempElementIndex].sales_qty = availableQty // product quantity
        }
      })
    }
  },

  async created() {
    await this.getSaleById(this.$route.params.saleId)
  },

  components: {
    InvoicePrint
  }
}
</script>